import { connect } from 'react-redux';
import { getAliasDataById, fetchRemoveAlias } from "../../../../reducers/account/aliases";
import RemoveAliasModal from "./RemoveAliasModal";
import { getActiveModal, hideModal, MODAL_REMOVE_ALIAS } from "../../../../reducers/common/activeModal";
import { resetSubmitFormData } from "../../../../reducers/common/submitForm";
import { getTranslation } from "../../../../reducers/common/localization";

const mapStateToProps = (state, { id }) => {
    return {
        isOpen: getActiveModal(state).modalKey === MODAL_REMOVE_ALIAS,
        data: getAliasDataById(state, id),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onRemove: (id) => {
            dispatch(fetchRemoveAlias(id));
        },
        onCancel: () => {
            dispatch(hideModal());
            dispatch(resetSubmitFormData());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RemoveAliasModal);



// WEBPACK FOOTER //
// ./src/components/accountManagement/aliasesManagement/removeAliasModal/RemoveAliasModal.container.js